import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Header from '../components/Header';
import './Certificates.css';

const CERTIFICATES = [
  {
    id: 1,
    image: '/images/certificates/cert-1.webp',
    number: 'РОСС RU.МЛ10.Н11349',
    validity: 'с 02.12.2025 по 01.12.2028',
    scope: 'Устройства распределительные низковольтные серий OCS, ACS, OBS, ADD, T-OCS, T-ACS и др. Соответствуют ТУ 25.99.29.190-001-47122495-2023, ГОСТ IEC 61439.1-2013.',
  },
  {
    id: 2,
    image: '/images/certificates/cert-2.webp',
    number: 'РОСС RU.HB78.H06681',
    validity: 'с 28.07.2026 по 27.07.2029',
    scope: 'Устройства распределительные низковольтные (расширенный перечень серий, включая OBZ, ABZ). Соответствуют ТУ 25.99.29.190-001-47122495-2025, ГОСТ IEC 61439.1-2013.',
  },
  {
    id: 3,
    image: '/images/certificates/cert-3.webp',
    number: 'РОСС RU.HB78.H07083',
    validity: 'с 05.08.2026 по 04.08.2029',
    scope: 'Коррозионная стойкость С5 — эксплуатация в агрессивных средах (морской климат, промышленные зоны). Соответствуют ГОСТ 34667.6-2021.',
  },
  {
    id: 4,
    image: '/images/certificates/cert-4.webp',
    number: 'РОСС RU.HB78.H07062',
    validity: 'с 05.08.2026 по 04.08.2029',
    scope: 'Климатическое исполнение УХЛ1. Соответствуют ТУ 25.99.29.190-001-47122495-2023, ГОСТ IEC 61439.1-2013.',
  },
  {
    id: 5,
    title: 'Отказное письмо Морского регистра',
    image: '/images/certificates/cert-5.webp',
    number: 'РОСС RU.HB78.H06681',
    validity: 'с 28.07.2026 по 27.07.2029',
    scope: 'Письмо Нижегородского филиала Российского морского регистра судоходства (№ 130-221-02-172088 от 01.09.2026): изделия относятся к Группе 1 Номенклатуры объектов технического наблюдения РС и техническому наблюдению не подлежат.',
  },
];

const Certificates = () => {
  const [active, setActive] = useState(null);

  return (
    <>
      <Header />
      <section className="certificates-hero">
        <div className="container-custom">
          <h1 className="certificates-hero-title">Сертификаты</h1>
          <p className="certificates-hero-lead">
            Продукция сертифицирована в системе добровольной сертификации «Прибор-Эксперт» и соответствует
            техническим условиям и ГОСТ IEC 61439.1-2013. Нажмите на сертификат, чтобы посмотреть его в полном размере.
          </p>
        </div>
      </section>

      <section className="certificates-section">
        <div className="container-custom">
          <div className="certificates-grid">
            {CERTIFICATES.map((cert) => (
              <button
                type="button"
                key={cert.id}
                className="certificate-card"
                onClick={() => setActive(cert)}
              >
                <img src={cert.image} alt={`${cert.title || 'Сертификат соответствия'} № ${cert.number}`} />
                <div className="certificate-card-info">
                  {cert.title && <span className="certificate-title">{cert.title}</span>}
                  <span className="certificate-number">№ {cert.number}</span>
                  <span className="certificate-validity">Действует {cert.validity}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <Modal show={!!active} onHide={() => setActive(null)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{active?.title || 'Сертификат'} № {active?.number}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={active?.image}
            alt={`${active?.title || 'Сертификат соответствия'} № ${active?.number}`}
            className="certificate-modal-img"
          />
          <p className="certificate-modal-scope">{active?.scope}</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Certificates;
